/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Architecture_BodyInputs */

const en_marketing_architecture_body = /** @type {(inputs: Marketing_Architecture_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Everything deploys as a single Cloudflare Worker: the app, the API, auth, jobs, crons, and workflows. One deploy, one log stream, and no service mesh between you and production. Cloudflare's primitives replace the usual fleet of services.`)
};

const es_marketing_architecture_body = /** @type {(inputs: Marketing_Architecture_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todo se despliega como un único Worker de Cloudflare: la aplicación, la API, la autenticación, los trabajos, los crons y los flujos de trabajo. Un despliegue, un flujo de registros y ninguna malla de servicios entre tú y producción. Las primitivas de Cloudflare sustituyen a la habitual flota de servicios.`)
};

const fr_marketing_architecture_body = /** @type {(inputs: Marketing_Architecture_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tout se déploie comme un unique Worker Cloudflare : l'application, l'API, l'authentification, les tâches, les crons et les workflows. Un déploiement, un flux de logs, et aucun maillage de services entre vous et la production. Les primitives de Cloudflare remplacent la flotte de services habituelle.`)
};

/**
* | output |
* | --- |
* | "Everything deploys as a single Cloudflare Worker: the app, the API, auth, jobs, crons, and workflows. One deploy, one log stream, and no service mesh between..." |
*
* @param {Marketing_Architecture_BodyInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_architecture_body = /** @type {((inputs?: Marketing_Architecture_BodyInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Architecture_BodyInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_architecture_body(inputs)
	if (locale === "es") return es_marketing_architecture_body(inputs)
	return fr_marketing_architecture_body(inputs)
});